<template>
    <div class="store-address">

        <h5>Adresse & Infos <a href="javascript:void(0);" @click="editStore()"><i class="mdi mdi-square-edit-outline"></i></a></h5>

        <div v-if="!editingStore">
            {{ address }}<br />
            {{ zip }} {{ city }}<br />
            <a :href="`mailto:${email}`">{{ email }}</a>
        </div>

        <div v-if="editingStore">
            <div class="mb-1">
                <div class="form-group mb-1">
                    <label class="mb-0">Adresse:</label>
                    <input type="text" class="form-control my-0" v-model="address">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">PLZ:</label>
                    <input type="text" class="form-control my-0" v-model="zip">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">Ort:</label>
                    <input type="text" class="form-control my-0" v-model="city">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">E-Mail:</label>
                    <input type="email" class="form-control my-0" v-model="email">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">Telefon:</label>
                    <input type="text" class="form-control my-0" v-model="phone">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">URL:</label>
                    <input type="text" class="form-control my-0" v-model="url">
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">Land:</label>
                    <input type="text" class="form-control my-0" v-model="country">
                </div>
            </div>
            <button class="btn btn-secondary" @click="cancelEditStore()">Abbrechen</button>
            <button class="btn btn-primary" @click="saveStore()">Speichern</button>
        </div>

    </div>
</template>

<script>
    export default {

    	data() {
            return {
                address: '',
                zip: '',
                city: '',
                email: '',
                phone: '',
                url: '',
                country: '',
                editingStore: false
            };
        },

        mounted() {
            this.address = this.storeData.address;
            this.zip = this.storeData.zip;
            this.city = this.storeData.city;
            this.email = this.storeData.email;
            this.phone = this.storeData.phone;
            this.url = this.storeData.url;
            this.country = this.storeData.country;
        },

        methods: {

            editStore() {
                this.editingStore = true;
            },
            cancelEditStore() {
                this.editingStore = false;
            },
            saveStore() {
                var _this = this;
                axios.put('/stores/' + this.storeData.id, this.$data)
                .then(function (response) {
                    if(response.status == 200) {
                        _this.editingStore = false;
                    }
                })
            }

        },

        props: ['storeData'],

    }
</script>